/**
 * 遊戲 HTML（CDN URL）的取檔 seam —— 以 url 為 key 去重。
 *
 * 同一份 HTML 在編輯器會被多處同時取用：畫布主預覽、獎項設計面板的預覽、
 * 以及「遊戲設計」slide-up（預覽 + 從字串抽 data island 取 gameConfig / gameConfigMeta）。
 * 各自 fetch 會對同一個 URL 打 2–3 次，故在此收斂成一次網路請求。
 *
 * 快取的是 promise，所以「同時取用」與「稍後再取用」都命中同一份結果；
 * 失敗不入快取（delete 後 rethrow），呼叫端仍可重試。
 */
const htmlPromiseByUrl = new Map();

export default function fetchGameHtml(url) {
    const cached = htmlPromiseByUrl.get(url);
    if (cached) return cached;

    // 弱掃誤判：唯一呼叫端 client/components/AIWebGame/GameIframe.js 在呼叫前已用
    // isAllowedCdnUrl() 驗證過 url——只允許 ALLOWED_CDN_DOMAINS 白名單內的網域
    // （assets.fevercdn.com / s3.ap-southeast-1.amazonaws.com），不通過就提前 return，
    // 見 client/components/AIWebGame/utils/securityConfig.js。
    // 且本專案為瀏覽器端 React SPA，請求由使用者自己的瀏覽器發出，不存在
    // 「伺服器代打內網」的 SSRF 攻擊面。
    // nosemgrep: nodejs_scan.javascript-ssrf-rule-node_ssrf
    const request = fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return response.text();
        })
        .catch(err => {
            htmlPromiseByUrl.delete(url);
            throw err;
        });

    htmlPromiseByUrl.set(url, request);
    return request;
}

/**
 * 清掉快取。重新上傳後後端可能沿用同一個 CDN URL 而內容已換，
 * 此時舊快取會讓編輯器預覽停在舊遊戲，故上傳成功後必須呼叫。
 */
export function clearGameHtmlCache() {
    htmlPromiseByUrl.clear();
}
